<template>
  <div class="medical-h770-res lg:mt-16 md:mt-12 mt-8">
    <b-modal
      ref="my-modal"
      centered
      :show.sync="isActiveLocal"
      header-classes="bg-primary items-center rounded-none text-lg uppercase font-bold"
      modal-content-classes="cust-medi-popup cust-overflow-y-grey"
      hide-footer
      class="overflow-y-hidden"
      body-class="p-0"
      title=""
    >
      <template slot="modal-title"
        ><h3 class="text-xl font-medium text-white">
          <!-- Build a Training Academy for Caregivers: -->
          {{ selectedCard.text }}
        </h3></template
      >
      <div class="d-block text-left">
        <p class="fsize16 px-7 py-2">
          {{ selectedCard.description }}
        </p>
      </div>
    </b-modal>
    <div class="relative">
      <div class="absolute bg-design-medc mob-hidden">
        <img
          src="@/assets/images/bg-des/bgd6.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="bg-design-medc-dots absolute mob-hidden">
        <img
          src="@/assets/images/caregiver/medc-dots.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="bg-design-mc-ecli absolute mob-hidden">
        <img
          src="@/assets/images/caregiver/ecli.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="w-full mx-auto md:pb-12 lg:pb-12 pb-0 lg:pt-0 md:pt-0 pt-2">
        <p class="title md:pb-4 lg:pb-4 pb-2 sm-fsize20 text-center font-bold">
          How do we aim to help?
        </p>

        <div
          class="grid md:grid-cols-3 lg:grid-cols-3 grid-cols-1 grid-rows-2 md:gap-4 lg:gap-10 gap-4 md:pt-10 lg:pt-10 pt-6"
        >
          <div
            class="md:p-6 lg:p-4 p-4 card2bg md:rounded-2xl lg:rounded-2xl rounded-lg cursor-pointer relative"
            v-for="(item, index) in medicalcards"
            :key="index"
            :style="{ 'background-color': item.color }"
            @click="showModal(item)"
          >
            <p class="pt-6 mc-title fsize20-14px">
              {{ item.text }}
            </p>
            <p class="pt-2 mc-subtitle ellipsis-3 fsize18-14px cursor-pointer">
              {{ item.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-center w-full lg:mt-0 md:mt-0 mt-4">
      <div>
        <p class="sm-fsize14 text-center lg:px-0 md:px-0 px-5">
          If you wish to learn more about our programmes then reach out to
        </p>
        <p class="text-center text-primary font-semibold underline">
          <a href="mailto:bhavana.issar@caregiversaathi.co.in"
            >bhavana.issar@caregiversaathi.co.in</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      selectedMedical: {},
      isDetailsActive: false,
      medicalcards: [
        {
          id: "01",
          //   text: "Build a Training Academy for Caregivers",
          text: "Caregiver Training Academy",
          description:
            "To create a pool of specialist caregivers for addressing the rising demand. We aim to train caregivers from marginalized backgrounds (urban poor) and upskill them, improve their digital literacy and enable employability. This will create livelihoods in the Care Economy.",
          img: require("@/assets/images/caregiver/med-c1.svg"),
          color: "#f1f1f199",
        },
        // {
        //   id: "02",
        //   text: "Digital directory of resources ",
        //   description:
        //     "For the easy access by Caregivers - supported by a helpline.",
        //   img: require("@/assets/images/caregiver/med-c2.svg"),
        //   color: "#e3ceff66",
        // },
        {
          id: "02",
          text: "Advocacy",
          // description:
          //   "Caregivers navigating chronic illnesses or long-term care face myriad challenges. While they ease the load of the healthcare system, their mental health can take a toll, especially during long-term care. They deserve to be seen and supported.",
          description:
            "Taking part in forums, leading conversations, and collaborating with policymakers to ensure caregivers are recognized and supported at all levels.",
          img: require("@/assets/images/caregiver/med-c4.svg"),
          color: "#e3ceff66",
        },
        {
          id: "03",
          text: "Community Building",
          description:
            "Creating spaces-both online and offline-where caregivers can connect, share, and find emotional support through support groups, healing circles, and interactive AMA sessions.",
          img: require("@/assets/images/caregiver/med-c2.svg"),
          color: "#e3ceff66",
        },
        {
          id: "04",
          // text: "Respite Care Programme",
          text: "Content to Educate and Inform",
          // description:
          //   "To build a workforce of companions who will be trained resources of providing respite care to family caregivers.",
          description:
            "Curating and creating medically verified content in multiple languages to ensure caregivers have access to accurate, relevant information on various health conditions like Dementia, Parkinson's, and ALS.",
          img: require("@/assets/images/caregiver/med-c3.svg"),
          color: "#f1f1f199",
        },
        {
          id: "05",
          // text: "Compassionate Caring in Long term Care",
          // description:
          //   "We conduct sensitivity and awareness programs online and offline. We conduct training programs for Caregivers so that they can endure the stress through practices of Compassionate Caring.",

          text: "Capability to Manage Long-term Care",
          description:
            "Developing and delivering training programs focused on resilience and emotional well-being, ensuring caregivers are empowered to manage the long journey of caregiving",
          img: require("@/assets/images/caregiver/als.svg"),
          color: "#f1f1f199",
        },
        {
          id: "06",
          // text: "Communities & Well-being",
          // description:
          //   "Facilitating support groups and healing circles for caregivers so that they can build communities of care.  ",
          text: "Care Directory (Curated Resources)",
          description:
            "Providing a digital directory of resources tailored to caregivers' needs, including professionals, services, and support networks by city and town, covering a wide range of caregiving needs.",
          img: require("@/assets/images/caregiver/covid19new.svg"),
          hlink: "https://covidhelp.caregiversaathi.co.in/",
          sayhere: "here.",
          color: "#e3ceff66",
        },
      ],
      selectedCard: {
        id: "01",
        text: "Build a Training Academy for Caregivers",
        description:
          "Our objective is to create a pool of specialist caregivers to address the rising caregiving needs for incurable.",
      },
    };
  },
  methods: {
    showModal(id) {
      this.selectedCard = id;
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    handleregister() {
      this.$router.push({ name: "register" });
    },
  },
};
</script>
